import { Sun } from "lucide-react";

export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden py-5 border-y ${
        dark ? "bg-brand-navy border-white/10" : "bg-white border-slate-100"
      }`}
      data-testid="marquee-strip"
    >
      <div className="marquee-track flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <span
            key={i}
            className={`flex items-center gap-10 whitespace-nowrap font-heading text-lg sm:text-xl font-semibold tracking-wide ${
              dark ? "text-white/70" : "text-brand-blue/70"
            }`}
          >
            {item}
            <Sun className="h-5 w-5 text-brand-orange" strokeWidth={2.2} />
          </span>
        ))}
      </div>
    </div>
  );
};
